import React from "react";
import { TradeIds, UploadXlsx } from "./index";
import CustomAccordion from "../../../components/Accordion";

const options = [
  {
    key: 1,
    title: "Intercambiar IDs",
    hide: false,
    processName: "",
    Component: (props) => <TradeIds {...props} />,
    expectedColumns: null,
  },
  {
    key: 2,
    title: "Cargar excel de tomas",
    hide: true,
    processName: "1_create_purchase_file",
    Component: (props) => <UploadXlsx {...props} />,
    titleField: "Tomas",
    // expectedColumns: [
    //   "Stock ID",
    //   "DOMINIO",
    //   "SITE",
    //   "SDP",
    //   "PRENDADO",
    //   "PRECIO",
    //   "COMENTARIO",
    //   "REGISTRO",
    //   "REQUIERE BAJA",
    //   "TIPO OPERACION",
    // ],
    expectedColumns: [
      "Stock ID",
      "DOMINIO",
      "SITE",
      "Estado",
      "SDP",
      "PRENDADO",
      "PRECIO",
      "COMENTARIO",
      "REGISTRO",
    ],
  },
  {
    key: 3,
    title: "Cargar excel de cedulas",
    hide: true,
    processName: "4_excel_update_delivery",
    Component: (props) => <UploadXlsx {...props} />,
    titleField: "Lugares de entrega de cedula",
    expectedColumns: [
      "Stock ID Journey",
      "Ubicacion",
      "Fecha de entrega",
      "Lugar de Entrega",
    ],
  },
  {
    key: 4,
    title: "Cargar excel de oportunidades de ventas",
    hide: true,
    processName: "8_excel_update_sells",
    Component: (props) => <UploadXlsx {...props} />,
    titleField: "Oportunidades de ventas",
    expectedColumns: [
      "Oportunidad",
      "Stock ID",
      "Dominio / Placa / Patente",
      "FECHA CREACION SO",
      "RAZON SOCIAL",
      "Correo electrónico",
      "Importe (bruto)",
      "CATEGORIA",
      "AUTO TRADE IN",
      "Método de pago",
      "PROVEEDOR FINANCIAMIENTO",
    ],
  },
  {
    key: 5,
    title: "Cargar retiro de documentación",
    hide: true,
    processName: "9_excel_sells_documentation",
    Component: (props) => <UploadXlsx {...props} />,
    titleField: "Retiro de documentacion de ventas",
    expectedColumns: [
      "ID",
      "Marca temporal",
      "Patente del vehículo",
      "Forma de entrega",
      "Hub",
      "Calle de recepción",
      "Altura de calle",
      "Piso",
      "Departamento",
      "Código postal",
      "Localidad",
    ],
  },
  {
    key: 6,
    title: "Cargar fechas de legalizaciones de ventas",
    hide: true,
    processName: "3_excel_sells_legalization_dates",
    Component: (props) => <UploadXlsx {...props} />,
    titleField: "Fechas de legalizaciones de ventas",
    expectedColumns: ["Venta Stock ID", "Venta Dominio", "Fecha legalizacion"],
  },
  {
    key: 7,
    title: "Cargar logística para compras",
    hide: true,
    processName: "2_excel_purchase_logistics",
    Component: (props) => <UploadXlsx {...props} />,
    titleField: "Listado para logística para compras",
    expectedColumns: [
      "Stock ID",
      "Dominio",
      "Registro Presentacion",
      "Logistico",
      "Fecha turno presentación",
    ],
  },
  {
    key: 8,
    title: "Cargar logística para ventas",
    hide: true,
    processName: "2_excel_sells_logistics",
    Component: (props) => <UploadXlsx {...props} />,
    titleField: "Listado para logística para ventas",
    expectedColumns: [
      "Stock ID",
      "Dominio",
      "Registro Presentacion",
      "Logistico",
      "Fecha turno presentación",
    ],
  },
  {
    key: 9,
    title: "Cargar fechas y estados de presentaciones para compras",
    hide: true,
    processName: "3_purchase_update_status",
    Component: (props) => <UploadXlsx {...props} />,
    titleField: "Listado para fechas y estados de presentaciones para compras",
    expectedColumns: [
      "Stock ID",
      "Dominio",
      "Estado Anterior",
      "Estado",
      "Registro",
      "Logistico",
      "Fecha entregado real",
      "Fecha turno presentacion",
      "Fecha presentacion real",
      "Fecha turno re-presentacion",
      "Fecha re-presentacion real",
      "Fecha turno retiro",
      "Fecha retiro real",
    ],
  },
  {
    key: 10,
    title: "Cargar fechas y estados de presentaciones para ventas",
    hide: true,
    processName: "1_sell_update_status",
    Component: (props) => <UploadXlsx {...props} />,
    titleField: "Listado para fechas y estados de presentaciones para ventas",
    expectedColumns: [
      "ID Oportunidad",
      "Dominio",
      "Estado Anterior",
      "Estado",
      "Registro",
      "Logistico",
      "Fecha entregado real",
      "Fecha turno presentacion",
      "Fecha presentacion real",
      "Fecha turno re-presentacion",
      "Fecha re-presentacion real",
      "Fecha turno retiro",
      "Fecha retiro real",
    ],
  },
];

const Settings = (props) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "10px",
        margin: "10px",
        backgroundColor: "white",
      }}
    >
      <div>
        {options.map((setting, index) => (
          <div key={index}>
            <CustomAccordion title={setting.title} index={index}>
              <setting.Component
                {...props}
                processName={setting.processName}
                title={setting.titleField}
                expectedColumns={setting?.expectedColumns}
              />
            </CustomAccordion>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Settings;
